<template>
  <div
    v-if="types.length"
    class="stt"
  >
    <span class="stt__label">
      <feather-icon
        icon="HelpCircleIcon"
        size="13"
      />
      {{ $t('despacho.requestSummary.suggested') }}
    </span>
    <ul class="stt__list">
      <li
        v-for="type in types"
        :key="type.id"
        class="stt__chip"
      >
        {{ type.name }}
      </li>
    </ul>
  </div>
</template>

<script>
/**
 * Tipos de equipe sugeridos pelo interrogatório, em destaque: bloco cinza com um card arredondado por tipo
 * (o mesmo desenho dos chips de "estado da equipe"). Some se não houver sugestão.
 */
export default {
  name: 'SuggestedTeamTypes',

  props: {
    types: { type: Array, default: () => [] },
  },
}
</script>

<style scoped>
.stt {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  margin: 10px 12px;
  padding: 10px 14px;
  border-radius: 10px;
  background: #f1f0f6;
}

.stt__label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #6e6b7b;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.stt__list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.stt__chip {
  padding: 3px 12px;
  border: 1px solid #d8d6de;
  border-radius: 16px;
  background: #fff;
  color: #5e5873;
  font-size: 0.82rem;
  font-weight: 700;
}

.dark-layout .stt { background: #2d3550; }
.dark-layout .stt__label { color: #b4b7bd; }
.dark-layout .stt__chip { border-color: #3b4253; background: #283046; color: #d0d2d6; }
</style>
